import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { CHECK_PROMOTION_AVAILABLE_FOR_USER, FANZONES } from '../../constants/apiUrls/apiUrls';
import callApi from '../../utils/callApi';
import { buildAnchorLink, buildAnchorCheckoutLink } from '../../utils/helpers';
import AnchorFanzone from '../FanZone/AnchorFanzone';

import './css/DiscountPage.css';
import EmailValidatorField from './EmailValidatorField';

function DiscountsPage(props) {
  const { activeCampaign, user, isCyberMondayPromo } = props;
  const { affiliateCode } = activeCampaign || {};
  const { authenticated = false } = user || {};
  const [anchors, setAnchors] = useState(undefined);
  const [errorMessage, setErrorMessage] = useState('');
  const [hash, setHash] = useState('');

  const CYBERMONDAY_CLASS = isCyberMondayPromo ? 'cyber-monday' : '';

  const checkActiveSubscriptionsAndFilterAnchors = useCallback((anchorsList) => {
    if (props.user?.user?.account?.affiliateCode === affiliateCode) {
      return [];
    }
    const anchorsNotSubscribedTo = anchorsList.filter((anchor) =>
      !user.user.account.anchorSubscriptions.
        find((a) => parseInt(a.subCategory, 10) === anchor.id));

    return anchorsNotSubscribedTo;
  }, []);

  const validateHashFromURL = useCallback(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has('code')) {
      const HASH_CODE = params.get('code');
      setHash(HASH_CODE);
      const URL = CHECK_PROMOTION_AVAILABLE_FOR_USER.replace('{hashCode}', HASH_CODE);
      callApi(URL, 'GET').then((res) => {
        if (res.status === 200 && res.data === 'OK') {
          setErrorMessage('');

        } else {
          setErrorMessage('This link is no longer valid!');
        }
      }).
        catch((err) => console.error(err));
    }
  }, [hash, errorMessage]);

  useEffect(() => {
    callApi(FANZONES, 'get').then((res) => {
      if (!user?.authenticated) {
        setAnchors(res.data);
      } else {
        setAnchors(checkActiveSubscriptionsAndFilterAnchors(res.data));
      }
    }).catch(() => {
      setAnchors(undefined);
    });

    validateHashFromURL();
  }, []);

  const getAnchorCheckoutURL = useCallback((anchor) => {
    if (isCyberMondayPromo) {
      return buildAnchorCheckoutLink(anchor.id, buildAnchorLink(anchor), '2022-cyber-monday-promo');
    }

    return buildAnchorCheckoutLink(anchor.id, buildAnchorLink(anchor), hash);
  }, [hash]);

  const renderAnchorsList = useCallback(() => {
    if (anchors?.length > 0) {
      return (
        <AnchorFanzone
          checkoutLink={getAnchorCheckoutURL}
          classes={'flex justify-center'}
          fanzones={anchors}
          isDiscountPage={true}
        />
      );
    }

    return (
      <div className="error-msg flex justify-center items-center">
        <h1 className="text-center white">Sorry! You are not eligible for this promotion</h1>
      </div>
    );
  }, [anchors]);

  return (
    <div className="content bg-dark">
      <div className="bg-dark">
        <div className="fanzone-offer">
          <div className={`fanzone-offer-header ${CYBERMONDAY_CLASS}`} />
          {!isCyberMondayPromo &&
          <ul className="flex justify-around items-center">
            <li>Low Monthly Subscription</li>
            <li>Access to exclusive content</li>
            <li>Nude videos &amp; photo galleries</li>
            <li>Watch sexy &amp; engaging live streams</li>
            <li>Chat &amp; interact with our lovely Anchors</li>
          </ul>}
        </div>
        {!authenticated && <EmailValidatorField errorMessage={errorMessage} user={user} />}
        <div className="container">
          <h4 className="text-center important-info">
            A unique link is sent via email on every calendar purchase. Please use this link to get your promotion.
            Please check your mail for emails from shop@nakednews.com. Also check your spam folder.
            Please move the mail to your inbox and follow the instructions provided.
          </h4>
        </div>
        {renderAnchorsList()}
      </div>
    </div>
  );
}

export default DiscountsPage;

DiscountsPage.propTypes = {
  activeCampaign: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};
